import React, { useState, useEffect, useCallback } from "react";

import { Col, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { BsArrowDown } from "react-icons/bs";
import { toast } from "react-toastify";
import TextSpinner from "../../../components/UI/Spinner/TextSpinner";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";
import PatExistenteDetalhes from "./components/PatExistenteDetalhes";
import useColumns from "./hooks/useColumns";
import constants from "../../Constants";

const PatExistente = ({ dadosOs }) => {
  const [rows, setRows] = useState([]);
  const [pageSize, setPageSize] = useState(25);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const { columns } = useColumns();
  const { request, data, errors, isLoading } = useApiClient();

  const handlePageChange = useCallback((newPageNumber) => {
    setPageNumber(newPageNumber);
  }, []);

  const handlePerRowsChange = useCallback((newPageSize) => {
    setPageSize(newPageSize);
    setPageNumber(1);
  }, []);

  const requestDadosOsHandler = useCallback(() => {
    if (dadosOs.acaoFiscal !== "" || dadosOs.acaoFiscal !== undefined) {
      const values = {
        AcaoFiscal: dadosOs.acaoFiscal,
        pageSize,
        pageNumber,
      };

      request(apiRoutes.fiscalizacao.ordemservico.patExistenteOs, values);
    }
  }, [request, dadosOs.acaoFiscal, pageSize, pageNumber]);

  useEffect(() => {
    requestDadosOsHandler();
  }, [requestDadosOsHandler]);

  useEffect(() => {
    if (data?.result) {
      const rowFilter = data.result
        .filter((item) => item.nuPat)
        .map((obj) => ({
          ...obj,
          nuDecisao: obj.nuDecisao === null || obj.nuDecisao === undefined ? "-" : obj.nuDecisao,
        }))
        .sort((a, b) => {
          if (a.linha < b.linha) return -1;
          return a.linha > b.linha ? 1 : 0;
        });

      setRows(rowFilter || []);
      setTotalRows(rowFilter.length ? rowFilter[0].totalRows : 0);
    }

    if (errors) {
      toast.error(errors.message);
    }
  }, [data, errors]);

  return (
    // <>
    <div style={{ width: "100%" }}>
      <Row>
        <Col>
          <DataTable
            noHeader
            keyField="linha"
            columns={columns}
            data={rows}
            progressPending={isLoading}
            noDataComponent="Nenhum PAT já existente encontrado para o contribuinte."
            progressComponent={<TextSpinner />}
            defaultSortFieldId={1}
            sortIcon={<BsArrowDown />}
            expandableRows={!!rows.length}
            expandableRowDisabled={(row) => row.disabled}
            expandableRowsComponent={(row) => PatExistenteDetalhes({ row })}
            pagination
            paginationServer
            sortable
            paginationTotalRows={totalRows}
            pointerOnHover
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            paginationComponentOptions={constants.paginationComponentOptions}
            paginationPerPage={pageSize}
          />
          {/* {totalPat > 0 && (
              <h5 style={{ marginTop: -55, marginLeft: 15 }}>{`Total de dias Prorrogados: ${totalPat}`}</h5>
            )} */}
        </Col>
      </Row>
      {/* )} */}
    </div>
    // </>
  );
};

export default PatExistente;
